import qs from 'query-string';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import * as Yup from 'yup';

import { useTranslation } from 'react-i18next';
import DisplayLoading from '../../../common/components/misc/DisplayLoading';
import { Drawer as NotificationDrawer } from '../../../common/components/notification/';
import * as CommonAuthService from '../../../common/services/auth/';
import * as Auth from '../../auth/';
import { config } from '../../common/';
import * as Unauth from '../../unauth/';
import BaseLayoutContainer, { BaseLayoutContainerProps } from './containers/BaseLayoutContainer';

const BaseLayout: React.FC<BaseLayoutContainerProps> = (containerProps) => {
    const { t } = useTranslation();
    Yup.setLocale({
        object: {
            noUnknown: t('common:validationMessages:yup:object:typeError'),
        },
        mixed: {
            required: t('common:validationMessages:required'),
            default: t('common:validationMessages:yup:mixed:default'),
            oneOf: ({ values }) => t('common:validationMessages:yup:mixed:oneOf', { values }),
            notOneOf: ({ values }) => t('common:validationMessages:yup:mixed:notOneOf', { values }),
            defined: t('common:validationMessages:yup:mixed:defined'),
        },
        date: {
            min: t('common:validationMessages:yup:date:min'),
            max: t('common:validationMessages:yup:date:max'),
        },
        number: {
            integer: t('common:validationMessages:yup:number:integer'),
            min: t('common:validationMessages:yup:number:min'),
            max: t('common:validationMessages:yup:number:max'),
        },
        string: {
            email: t('common:validationMessages:yup:string:email'),
            min: t('common:validationMessages:yup:string:min'),
            max: t('common:validationMessages:yup:string:max'),
        }
    });
    return (
        <BaseLayoutContainer {...containerProps}>
            {(props) => {
                const { requireAuthentication } = CommonAuthService.Service.createServiceActions(config);
                if (props.isReadyToRender) {
                    return (
                        <main>
                            <div className={'wrapper'}>
                                <NotificationDrawer />
                                <Switch>
                                    <Route path={[`${config.BaseURL}/auth/callback`, `${config.AlternativeBaseURL}/auth/callback`]} component={Auth.OAuthCallback} />
                                    {/* <Route path={[`${config.BaseURL}/signup/:regtype?/:token?`, `${config.AlternativeBaseURL}/signup/:regtype?/:token?`]} component={Auth.SignUpLayout} /> */}
                                    <Route path={[`${config.BaseURL}/signup/:regtype?/:token?`, `${config.AlternativeBaseURL}/signup/:regtype?/:token?`]} component={() => { window.location.assign(`${config.IFrameRedirectParent}/prime`); return null; }} />
                                    <Route path={[`${config.BaseURL}/surveyfollowup`, `${config.AlternativeBaseURL}/surveyfollowup`]} component={Auth.SurveyFollowupLayout} />
                                    <Route path={[`${config.BaseURL}/login`, `${config.AlternativeBaseURL}/login`]} component={Auth.SignInLayout} />
                                    <Route path={[`${config.BaseURL}/autherror`, `${config.AlternativeBaseURL}/autherror`]} component={Auth.AuthError} />

                                    <Route path={`${config.BaseURL}/primelanding_twonly`} component={Unauth.PrimeLandingLayout} />
                                    <Route path={`${config.BaseURL}/tugaiframe`} component={Unauth.TugaIframeLayout} />

                                    {/* Simulador de Manutencoes - Nao autenticado */}
                                    <Route path={`${config.BaseURL}/packages`} component={Unauth.PackagesLayout} />

                                    {/* Redirects */}
                                    <Route path={[`${config.BaseURL}/register`, `${config.AlternativeBaseURL}/register`]} component={() => { window.location.assign(`${config.IFrameRedirectParent}/prime/signup`); return null; }} />
                                    <Route path={[`${config.BaseURL}/logout`, `${config.AlternativeBaseURL}/logout`]} component={() => { window.top!.location.href = config.LogoutURL; return null; }} />
                                    <Route path={[`${config.BaseURL}/legalnotice`, `${config.AlternativeBaseURL}/legalnotice`]} component={() => { window.top!.location.href = config.LegalNoticeURL; return null; }} />
                                    <Route path={[`${config.BaseURL}/privacystatement`, `${config.AlternativeBaseURL}/privacystatement`]} component={() => { window.top!.location.href = config.PrivacyStatementURL; return null; }} />
                                    <Route
                                        path={[`${config.BaseURL}/activation`, `${config.AlternativeBaseURL}/activation`]}
                                        component={
                                            () => {
                                                const parsed = qs.parse(window.location.search);
                                                if (parsed && parsed.token) {
                                                    window.top!.location.href = config.ActivationURL + '&token=' + parsed.token;
                                                }
                                                return null;
                                            }
                                        }
                                    />

                                    <Route
                                        path={[`${config.BaseURL}/resetpassword`, `${config.AlternativeBaseURL}/resetpassword`]}
                                        component={
                                            () => {
                                                const parsed = qs.parse(window.location.search);
                                                if (parsed && parsed.token) {
                                                    window.top!.location.href = config.ResetPasswordURL + '&token=' + parsed.token;
                                                }
                                                return null;
                                            }
                                        }
                                    />
                                    <Route component={requireAuthentication(Auth.AuthWrapper)} />
                                </Switch>
                            </div>
                        </main>
                    );
                }
                return (
                    <DisplayLoading validation={true} />
                );
            }}
        </BaseLayoutContainer>
    );
};

export default BaseLayout;
